import { ConsignmentRootDataContext } from 'Pages/UserDashboard/Consignment/Contexts/ConsignmentRootData';
import { useOutsideAlerter } from 'helpers/dom';
import React, { useContext, useRef, useState } from 'react';
import { IconContext } from 'react-icons';
import { CgSortAz } from 'react-icons/cg';

const Sort: React.FC = () => {
  const consignmentContext = useContext(ConsignmentRootDataContext);
  const form = consignmentContext.value.formTabToolbar;
  const [isSortOpen, setSortOpen] = useState(false);
  const [currentSort, setCurrentSort] = useState('createdAt_desc');

  const wrapperRefSort = useRef(null);
  useOutsideAlerter(wrapperRefSort, () => setSortOpen(false));
  const toggleSort = () => setSortOpen(!isSortOpen);
  const doSortThenSearch = (sortBy: string) => {
    setCurrentSort(sortBy);
    toggleSort();
    form?.setFieldValue('sort_by', sortBy);
  };

  return (
    <div className={'sort-container'} ref={wrapperRefSort}>
      <div className={'sort-parent'} onClick={toggleSort}>
        <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
          <div>
            <CgSortAz />
          </div>
        </IconContext.Provider>
        <span className={'text'}>Sort</span>
      </div>
      {isSortOpen && (
        <div className={`sort-pop-up`}>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_desc')}
          >
            Latest
          </div>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_asc')}
          >
            Earliest
          </div>
        </div>
      )}
    </div>
  );
};

export default Sort;
